var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "j-form-container",
            { attrs: { disabled: _vm.formDisabled } },
            [
              _c(
                "a-form-model",
                {
                  ref: "form",
                  attrs: {
                    slot: "detail",
                    model: _vm.model,
                    "label-col": _vm.labelCol1,
                    "wrapper-col": _vm.wrapperCol1,
                    rules: _vm.validatorRules
                  },
                  slot: "detail"
                },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["cs.venuecode"],
                                prop: "venuecode"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "系统自动生成",
                                  disabled: true
                                },
                                model: {
                                  value: _vm.model.venuecode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "venuecode", $$v)
                                  },
                                  expression: "model.venuecode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["cs.venuename"],
                                prop: "venuename"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: this.language["cs.venuename"],
                                  maxLength: 100
                                },
                                model: {
                                  value: _vm.model.venuename,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "venuename", $$v)
                                  },
                                  expression: "model.venuename"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["cs.venuestatus"],
                                prop: "status"
                              }
                            },
                            [
                              _c("j-dict-select-tag", {
                                attrs: {
                                  type: "select",
                                  dictCode: "cs_venuestatus"
                                },
                                model: {
                                  value: _vm.model.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "status", $$v)
                                  },
                                  expression: "model.status"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["cs.venuecategory"],
                                prop: "category"
                              }
                            },
                            [
                              _c("j-dict-select-tag", {
                                attrs: {
                                  type: "select",
                                  dictCode: "cs_venuecategory"
                                },
                                model: {
                                  value: _vm.model.category,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "category", $$v)
                                  },
                                  expression: "model.category"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label:
                                  _vm.language[
                                    "labor.contractor.detailAddress"
                                  ],
                                labelCol: _vm.labelCol1,
                                wrapperCol: _vm.wrapperCol1,
                                prop: "address"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: this.language[
                                    "labor.contractor.detailAddress"
                                  ],
                                  maxLength: 500
                                },
                                model: {
                                  value: _vm.model.address,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "address", $$v)
                                  },
                                  expression: "model.address"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["common.uploadPicture"],
                                labelCol: _vm.labelCol1,
                                wrapperCol: _vm.wrapperCol1,
                                prop: "files"
                              }
                            },
                            [
                              _c("j-image-upload", {
                                staticClass: "avatar-uploader",
                                attrs: {
                                  text: "上传",
                                  isMultiple: true,
                                  disabled: _vm.disableSubmit
                                },
                                model: {
                                  value: _vm.model.files,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "files", $$v)
                                  },
                                  expression: "model.files"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }